import React, { useEffect } from "react";
import type { MenuProps } from "antd";
import { Dropdown, notification, Typography, Flex } from "antd";
import { useAuth0 } from "@auth0/auth0-react";
import "./index.css";
import { ROUTES } from "../../../config/routes";
import { ReducerState } from "../../../types";
import { ConnectedProps, connect } from "react-redux";
import { ReactComponent as VectechTextIconSvg } from "../../../assets/icons/Vectech Text - Main v2.svg";
import { ReactComponent as UserSvg } from "../../../assets/icons/userIcon.svg";
import { useLocation } from "react-router-dom";
import { Link } from "react-router-dom";

const { Title } = Typography;

const mapStateToProps = (state: ReducerState) => {
  return {
    notifications: state.notifications,
  };
};

const connector = connect(mapStateToProps, {});

type Props = ConnectedProps<typeof connector> & {
  // Extra props go here
};

const Navbar: React.FC<Props> = ({ notifications }) => {
  const { user, isAuthenticated, logout } = useAuth0();
  const [api, contextHolder] = notification.useNotification();
  const location = useLocation();

  useEffect(() => {
    getNotify();
    // eslint-disable-next-line
  }, [notifications?.count]);

  const getNotify = () => {
    const notiArray = Object.values(notifications?.notifications);
    if (notiArray?.length > 0) {
      api[notiArray[notiArray?.length - 1].severity]({
        message: "Notification",
        description: notiArray[notiArray?.length - 1].message,
        duration: 5,
      });
    }
  };

  const logoutWithRedirect = () =>
    logout({
      logoutParams: {
        returnTo: window.location.origin,
      },
    });

  const items: MenuProps["items"] = [
    {
      label: (
        <a href="/#" onClick={() => logoutWithRedirect()}>
          Logout
        </a>
      ),
      key: "1",
    },
  ];

  const headers = [
    {
      text: <VectechTextIconSvg className="logo-header" />,
    },
    { text: "Home", route: ROUTES.home },
    { text: "Traps", route: ROUTES.traps_and_locations },
    { text: "Image Catalog", route: ROUTES.image_catalog },
    { text: "Admin", route: ROUTES.admin },
  ];

  return (
    <>
      {contextHolder}
      {isAuthenticated && (
        <nav className="">
          <div className="nav-texts mt-6">
            {headers.map((header, index) => {
              const isActive =
                header.route &&
                (header.route === "/"
                  ? location.pathname === "/"
                  : location.pathname.includes(header.route));
              return (
                <Link
                  key={`nav-text-${index}`}
                  to={header.route || "/"}
                  className={isActive ? "active" : ""}
                >
                  <Title level={5}>{header.text}</Title>
                </Link>
              );
            })}
          </div>

          <ul>
            <li className="big-screens">
              <Dropdown
                menu={{ items }}
                trigger={["click"]}
                placement="bottomRight"
              >
                <Flex
                  align="center"
                  gap={8}
                  style={{ cursor: "pointer" }}
                  justify={"center"}
                >
                  <span className="m-auto">
                    <UserSvg width={22} height={22} />
                  </span>
                  <Title level={5} style={{ margin: 0 }}>
                    {user?.name}
                  </Title>
                </Flex>
              </Dropdown>
            </li>
          </ul>
        </nav>
      )}
    </>
  );
};

export default connector(Navbar);
